(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('strengthGauge', function(resourceService) {
    return {
        restrict: 'A',
        link(scope, el) {
            el.addClass('strength-gauge');
            el.append('<div class="text"></div>');
            el.append('<div class="status"><span /><span /><span /><span /><span /><span /></div>');

            scope.$on('passwordStrength', function(ev, data) {
                el.find('.text').text(resourceService.get(data.label));
                el.find('.status').removeClass().addClass(`status ${data.label}`).find('span').each(function(i, elem) {
                    if (i < data.strength) {
                        $(elem).addClass('on');
                    } else {
                        $(elem).removeClass();
                    }
                });
            });
        }
    };
});
})();
